<template>
    <div>
        <div class="tabletPaddingPrice marginTopLarge">
            <el-steps class="stepGuide displayBlock" :active=stepCount align-center>
                <el-step icon="icon-step-circle stepSize" title="Artwork Preview"></el-step>
                <el-step icon="icon-step-circle stepSize" title="Select Print Options"></el-step>
                <el-step icon="icon-step-circle stepSize"  title="Checkout"></el-step>
            </el-steps>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'stepguide',
        props: {
            stepCount: Number
        }
    }
</script>